import React from "react";
import { useHoldingsController } from "../hooks/useHoldingsController";
import { HoldingsHeader } from "./HoldingsHeader";
import { HoldingsCard } from "./HoldingsCard";
import { ReportingPeriodTimeline } from "../../reporting-periods";

export const Holdings = () => {
  const controller = useHoldingsController();

  return (
    <div className="w-full">
      <HoldingsHeader onAddHolding={() => controller.openModal("add")} />

      <ReportingPeriodTimeline />

      <HoldingsCard
        searchQuery={controller.searchQuery}
        setSearchQuery={controller.setSearchQuery}
        isLoading={controller.isLoading}
        filteredHoldings={controller.filteredHoldings}
        onViewHolding={(holding) => controller.openModal("view", holding)}
        onConfirmHolding={controller.confirmHolding}
        onDeleteHolding={controller.deleteHoldingHandler}
      />

      {/* Modal components would go here once implemented */}
    </div>
  );
}; 